import { render, staticRenderFns } from "./PostPurchaseModal.vue?vue&type=template&id=71ddd916"
import script from "./PostPurchaseModal.vue?vue&type=script&lang=js"
export * from "./PostPurchaseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports